import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { ServiceBase } from '../service-base';

// Modèles
import { AssistantAuthorizationRequest } from 'src/app/@shared/models/interfaces/assistant-authorization-request.model';
import { Client } from 'src/app/@shared/models/client/client.model';

const CLASS_NAME = 'AssistantAuthorizationRequest';
const ENDPOINT = `/oauth/authorize/`;

/** Réponse de l'autorisation : l'adresse de retour vers l'assistant, porteuse du code. */
export interface AssistantAuthorizationResult {
    redirectUrl: string;
}

/**
 * Page d'autorisation d'un assistant IA (#1312). Les deux appels partent avec le seul
 * jeton de session : la page est hors dossier, aucun en-tête `Context-Client` n'est posé.
 */
@Injectable({
    providedIn: 'root'
})
export class AssistantAuthorizationService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }

    /**
     * Enregistre la décision de l'utilisateur : l'assistant de la demande est autorisé
     * sur le dossier choisi, et un seul.
     * @param request La demande d'autorisation, telle que lue par {@link getRequest$}
     * @param client Le dossier choisi
     */
    public authorize$(request: AssistantAuthorizationRequest, client: Client): Observable<AssistantAuthorizationResult> {
        return this._postActionValue$<AssistantAuthorizationResult>(this.routes.create, {
            clientId: request.assistant.clientId,
            redirectUri: request.redirectUri,
            codeChallenge: request.codeChallenge,
            codeChallengeMethod: request.codeChallengeMethod,
            state: request.state,
            client: { id: client.id }
        });
    }

    /**
     * Contrôle la demande formée par l'assistant et renvoie de quoi afficher la page :
     * l'assistant qui demande et les dossiers éligibles. `null` quand le serveur refuse
     * la demande — son message est alors relayé en toast.
     * @param params Les paramètres de l'URL de la page, transmis tels quels
     */
    public getRequest$(params: { [key: string]: string }): Observable<AssistantAuthorizationRequest | null> {
        const query = new URLSearchParams(params).toString();
        return this.getList$({
            url: `${this.endpoint}request/?${query}`,
            resultCardinality: 'one'
        });
    }
}
